import { render, staticRenderFns } from "./cityBroadCastPage.vue?vue&type=template&id=b71ffdaa"
import script from "./cityBroadCastPage.vue?vue&type=script&lang=js"
export * from "./cityBroadCastPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports